import processSpotlightItemsResponse from './processSpotlightItemsResponse';
import onSpotlightItemsFetched from '../actions/onSpotlightItemsFetched';
import fetchSpotlightItemsService from '../services/fetchSpotlightItemsService';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { getInboxTableView } from 'owa-mail-triage-table-utils/lib/getInboxTableView';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

export default function initializeSpotlight() {
    const inboxTableView = getInboxTableView(
        FocusedViewFilter.None,
        InboxClassificationFilter.None
    );

    fetchSpotlightItemsService(inboxTableView).then(async (response: Response) => {
        const spotlightItems = await processSpotlightItemsResponse(response, inboxTableView);

        const isConversationView =
            inboxTableView.tableQuery.listViewType === ReactListViewType.Conversation;

        onSpotlightItemsFetched(spotlightItems, isConversationView);
    });
}
